import React, { Fragment, useState, useContext, useMemo } from 'react';
import { Dialog } from '../site'
import { SiteContext } from '../site/siteContext'
import { Text, Button } from '../html';
import { Content } from './ContentType'
import { ContentEditor } from './ContentEditor'

/**
 * Create Content Dialog
 */
export const CreateContentDialog = ({ label, type, value = {}, filter, validator, onOK, className, outlined=true }) => {

    const site = useContext(SiteContext);
    const [form, setForm] = useState(value)
    const [isValid, setValid] = useState(false)
    const [errors, setErrors] = useState([])

    function change(form) {
        setForm(form)
        if (validator) {
            const { validation, errors = [] } = validator(form)
            setValid(validation)
            setErrors(errors)
        } else {
            setValid(true)
        }
    }

    function onAction(action) {
        if (action === 'OK' && onOK) onOK(Object.assign({}, value, form))
        site.closeDialog();
    }

    function filterForm(field, content) {
        const visible =  field.required === true || field.optional === true
        return filter ? visible && filter(field, content) : visible
    }

    const actions = (
        <Fragment>
            <Button label="CLOSE" action={() => onAction("CLOSE")} />
            <div className="expand" />
            <Button label="OK" action={() => onAction("OK")} disabled={!isValid} raised />
        </Fragment>
    )

    const title = <Text use="headline6">{label}</Text>
    const content = new Content(type, form)
    return (
        <Dialog title={title} open={true} onAction={onAction} actions={actions}>
            <ContentEditor content={content} onChange={change} filter={filterForm} className={className} outlined={outlined}/>
            {errors.map(error => <Text use="overline" tag="div" className="error">{error}</Text>)}
        </Dialog>
    )
}